import { gql } from '__generated__'

export const GetResumeUrl = gql(/* GraphQL */ `
    query DownloadResume($documentId: String!, $forceInline: Boolean) {
        download(documentId: $documentId, forceInline: $forceInline) {
            url
        }
    }
`)
